import React from 'react';

import type { ReactNode } from 'react';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import styles from '../textField.module.scss';

/** Custom props */
type Props = {
  /** The content of the component */
  children?: ReactNode;
  /** Custom class to overwrite default styling if needed */
  className?: string;
};

export function TrailingIcon(props: Props) {
  const { children, className } = props;

  const classNames = cx(styles[toCamelCase('textField', 'trailingIcon')], className);

  return (
    <span className={classNames} data-testid="textField-trailingIcon">
      {children}
    </span>
  );
}

export default TrailingIcon;
